import { useEffect, useRef, useState, memo, useMemo } from 'react';

import {
  activityOverseaCouponTips,
  isCounponUnavailableForOversea,
  selectProductLabel,
  getMarketCouponLabelShow,
} from '@lcsc-ui/apis/activity';
import { loadProductSeries } from '@lcsc-ui/apis/list';
import { selectProductFavorite } from '@lcsc-ui/apis/member';
import { searchAlias, searchMoreChannel } from '@lcsc-ui/apis/overseas';
import EmptyText from '@lcsc-ui/components/EmptyText';
import MixSortFilter from '@lcsc-ui/components/MixSortFilter';
import ProductItem from '@lcsc-ui/components/ProductItem/productItem';
import ProductList from '@lcsc-ui/components/ProductList';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { getPaginationInfo } from '@lcsc-ui/utils/common';
import Utils from '@lcsc-ui/utils/Utils';
import { Spin } from 'antd';
import { throttle, uniqWith } from 'lodash-es';
import dynamic from 'next/dynamic';

const DynamicListFloatRightAdvert = dynamic(() => import('@lcsc-ui/components/ListFloatRightAdvert'), { ssr: false });
const DynamicNormalPagination = dynamic(() => import('@lcsc-ui/components/NormalPagination'), { ssr: false });
const DynamicToolbar = dynamic(() => import('@lcsc-ui/components/ToolBar'), { ssr: false });

import Banner from './components/Banner';
import FilterCondition from './components/FilterCondition';

import { secondQueryHotProduct } from '@/apis/ListApi';

const aliasMap = new Map();
let moreChannelList = [];
let observer = null;
const maxObserveIndex = 5;
let showOsCoupon = false;

function HotProductDetailIndex(props) {
  const { showStockBtn } = props;
  const [searchResult, setSearchResult] = useState(props?.searchResult);
  const [paginationInfo, setPaginationInfo] = useState(
    getPaginationInfo({
      currentUrl: '',
      currentPage: 1,
      countPage: searchResult?.countPage || parseInt(searchResult?.totalCount / searchResult?.pageSize),
      totalCount: searchResult?.totalCount,
      pageSize: searchResult?.pageSize,
    })
  );
  const [moreChannelVO, setMoreChannelVO] = useState({});
  const [marketLabelVO, setMarketLabelVO] = useState({});
  // 海外代购优惠券
  const [moreOsCoupon, setMoreOsCoupon] = useState({});
  const productItemRefs = useRef([]);
  const [dhAndTeAndRoCoupon, setDhAndTeAndRoCoupon] = useState({}); // 展示立创订货、te、rochester的优惠券

  const [sendSearchParams, setSendSearchParams] = useState({
    currentPage: props.paginationInfo?.currentPage || 1, // 页码
    pageSize: 30, // 条数
    brandIdFilter: '', // 原本的queryProductGradePlateId  品牌id字段
    standardFilter: '', // 原本的queryProductStandard  封装规格过滤
    brandPlaceFilter: '', // 原本的queryPlaceProduction  品牌产地(筛选器中的国际国产)
    spotFilter: 1, // 原本的showOutSockProduct 现货 勾选0 未勾选1
    discountFilter: 1, // 原本的showDiscountProduct 折扣 勾选0 未勾选1
    startPrice: '', // 原本的queryBeginPrice 开始单价
    endPrice: '', // 原本的queryEndPrice  结束单价
    sortNumber: 0, // 原本的querySortBySign 0 综合 1 价格升序 2 价格降序 9 总库存升序 8 总库存降序 6 销量 10 广东库存降序 11 广东库存升序 12 江苏库存降序 13 江苏库存升序
    queryParameterValue: '', // 商品参数查询条件
    lastParamName: '', // 最后一个点击的商品参数
    keyword: '', // 本页搜索关键字
    secondKeyword: '', // 二次搜索关键字
    hasDataFile: false, // 数据手册 勾选true 未勾选false
    demandNumber: '', // 需求数量
    satisfyStockType: '', // 价格/库存筛选里面的库存
    queryProductTypeCode: '', // 父级目录过滤
  });
  const [secondQueryIsEmpty, setSecondQueryIsEmpty] = useState(false); // 判断二次筛选是否为空 为true 则为空 需要清空筛选器的内容 且出现空提示
  const [requestLoading, setRequestLoading] = useState(false); // 防止重复请求
  const [favoriteList, setFavoriteList] = useState([]);
  const [anchorHeaderCls, setAnchorHeaderCls] = useState('');
  const [anchorHeaderShadow, setAnchorHeaderShadow] = useState('');
  const [productSpuMap, setProductSpuMap] = useState({});
  const [productConnectorMap, setProductConnectorMap] = useState({});
  const [hasInit, setHasInit] = useState(false);

  const catalogFilterRef = useRef(null);

  useEffect(() => {
    jumpTo();
    init();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      observer?.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (hasInit) {
      observerProductItem();
      handleLoadProductSeries(searchResult?.productRecordList?.length);
    }
  }, [searchResult?.productRecordList, hasInit]);

  const handleScroll = throttle(() => {
    addAnchorHeaderCls();
    if (productItemRefs?.current?.length > 0) {
      productItemRefs?.current.forEach((item) => {
        item?.checkButtonPosition();
      });
    }
  }, 200);

  const addAnchorHeaderCls = () => {
    setTimeout(() => {
      const dom = document.querySelector('#float-header');
      setAnchorHeaderCls(dom ? 'top-[72px]' : '');
      const anchorNavDom = document.querySelector('.anchor-header');
      setAnchorHeaderShadow(
        Math.ceil(anchorNavDom?.getBoundingClientRect()?.top) === 72
          ? 'shadow-[0_9px_19px_0px_rgba(13,28,51,0.15)]'
          : ''
      );
    }, 320);
  };

  // 监听商品列表是否在可视访问
  function observerProductItem() {
    if (observer) {
      observer?.disconnect();
      observer = null;
    }
    moreChannelList = searchResult?.productRecordList?.map((item) => {
      return {
        uuid: item?.productVO?.productId,
        productCode: item?.productVO?.productCode,
        productModel: item?.productVO?.productModel,
        brandId: item?.productVO?.productGradePlateId,
        brandName: item?.productVO?.productGradePlateName,
      };
    });
    getFavoriteList();
    const cacheList = []; // 记录请求过的groupIndex;
    observer = new IntersectionObserver((entries) => {
      entries.forEach(
        (entry) => {
          if (entry.isIntersecting) {
            let startIndex = entry?.target?.dataset?.index;
            if (!startIndex) {
              return;
            }
            startIndex = Number(startIndex);
            if (cacheList.includes(startIndex)) {
              return;
            }
            Promise.allSettled([getMarketLable(startIndex), getMoreChannel(startIndex)]).then(() => {
              cacheList.push(startIndex);
            });
          }
        },
        {
          rootMargin: '0px', // 不增加额外的外边距
          threshold: [0, 0.5, 1.0], // 在交集比例为 0%, 50%, 100% 时触发回调
        }
      );
    });
    document.querySelectorAll('.product-group-leader').forEach((el) => {
      observer.observe(el);
    });
  }

  // 获取同系列sku 配套连接器
  const handleLoadProductSeries = async (len) => {
    if (!len) return false;
    const params = {
      productCodeList: searchResult?.productRecordList.map((item) => item.productVO.productCode),
    };
    const res = await loadProductSeries(params);
    if (res?.code === 200) {
      setProductConnectorMap(res?.result?.productConnectorMap || {});
      setProductSpuMap(len > 3 ? res?.result?.productSpuMap || {} : {});
    }
  };

  // 获取运营标签
  function getMarketLable(startIndex) {
    const list = moreChannelList.slice(startIndex, startIndex + maxObserveIndex);
    if (list.length === 0) {
      return;
    }
    const params = list.map((item) => item.uuid);
    selectProductLabel(params).then((res) => {
      const list = res?.result;
      if (list?.length > 0) {
        const obj = {};
        list.forEach((item) => {
          obj[item?.productId] = item;
        });
        setMarketLabelVO((prev) => ({
          ...prev,
          ...obj,
        }));
      }
    });
  }

  // 获取收藏列表
  function getFavoriteList() {
    if (moreChannelList.length === 0) {
      return;
    }
    const productIds = moreChannelList.map((item) => item.uuid).join();
    selectProductFavorite({ productIds })
      .then((res) => {
        setFavoriteList(res?.result?.map((item) => item.toString()) || []);
      })
      .catch((error) => {
        console.error('获取收藏列表失败', error);
      });
  }

  const jumpTo = () => {
    // 跳转手机
    if (Utils.isMobile()) {
      const env = process.env.NEXT_PUBLIC_APP_ENV;
      window.location.href = `https://${env}m.szlcsc.com/pages/hot-product-list/index`;
    }
  };

  function init() {
    buriedPoint({
      op: 'view',
      ty: 'enter',
      data: searchResult?.productRecordList.map((item) => item?.productVO?.productId).join(','),
    });
    Utils.asyncAll([searchAlias(), isCounponUnavailableForOversea()]).then(([alias, ovease]) => {
      if (alias?.result?.length) {
        alias.result.forEach((item) => {
          aliasMap.set(item?.provider, item);
        });
      }
      showOsCoupon = !ovease?.result;
      setHasInit(true);
      // 如果url含有以下参数，则页面再次发起请求
      const clientQuery = ['firstCode', 'queryProductTypeCode', 'queryProductGradePlateId'];
      if (clientQuery.some((item) => Utils.getUrlParam(item))) {
        const catalogIdFilter = Utils.getUrlParam('queryProductTypeCode');
        const brandIdFilter = Utils.getUrlParam('queryProductGradePlateId');
        changeSendSearchParams({
          firstCode: Utils.getUrlParam('firstCode'),
          catalogIdFilter: catalogIdFilter,
          brandIdFilter,
        });
        setSendSearchParams({
          ...sendSearchParams,
          catalogIdFilter,
          brandIdFilter,
        });
      }
    });
  }

  const loadMarketCouponLabelShow = async (productCodeList = []) => {
    if (!productCodeList.length) return;
    const res = await getMarketCouponLabelShow(productCodeList);
    if (res?.code === 200 && res.result) {
      const dataMap = {};
      Object.keys(res.result).forEach((item) => {
        dataMap[item] = {
          ...res.result[item],
          ...(res.result[item]?.couponInfo || {}),
        };
      });
      setDhAndTeAndRoCoupon((prevState) => {
        return {
          ...prevState,
          ...dataMap,
        };
      });
    }
  };

  function setOverseaCoupon(list, isMore) {
    if (!showOsCoupon) {
      return;
    }
    const arr = uniqWith(list, (a, b) => a?.provider === b?.provider && a?.brandId === b?.brandId);
    if (arr.length > 0) {
      activityOverseaCouponTips(arr).then((res) => {
        if (res?.result) {
          if (isMore) {
            setMoreOsCoupon((prev) => ({
              ...prev,
              ...res?.result,
            }));
          }
        }
      });
    }
  }

  const changeSendSearchParams = (params, needTip = true, cb, needUpdateAgg = true) => {
    if (requestLoading) {
      return;
    }
    setRequestLoading(true);
    const updatedParams = {
      ...sendSearchParams,
      ...params,
    };
    setSendSearchParams(updatedParams);
    handleSecondQueryList(updatedParams, needTip, cb, needUpdateAgg);
  };

  const handleSecondQueryList = async (params = sendSearchParams, needTip = true, cb, needUpdateAgg = true) => {
    const res = await secondQueryHotProduct(params).finally(() => {
      setRequestLoading(false);
      // 第一次查询后,删除firstCode
      if (params?.firstCode) {
        setSendSearchParams({
          ...params,
          firstCode: '',
        });
      }
      typeof cb === 'function' && cb();
    });
    // 如果已经吸顶 触发二次搜索时 需要滚动到顶部
    const anchorNavDom = document.querySelector('.anchor-header');
    if (Math.ceil(anchorNavDom?.getBoundingClientRect()?.top) === 72) {
      window.scrollTo({
        top: 0,
        smooth: true,
      });
    }
    if (res?.code === 200) {
      if (res?.result?.searchResult?.productRecordList?.length === 0) {
        if (needTip) {
          setSecondQueryIsEmpty(true);
        }
      } else {
        setSecondQueryIsEmpty(false);
      }
      if (needUpdateAgg) {
        catalogFilterRef?.current?.changeParameterDataList(res?.result?.aggregateResultVO);
      }
      setSearchResult(res?.result?.searchResult);
      //二次查询为空 显示对应文案 且将筛选器重置
      const paginationInfoState = getPaginationInfo({
        currentUrl: '',
        currentPage: params.currentPage,
        countPage:
          res?.result?.searchResult?.countPage ||
          parseInt(res?.result?.searchResult?.totalCount / res?.result?.searchResult?.pageSize),
        totalCount: res?.result?.searchResult?.totalCount,
        pageSize: res?.result?.searchResult?.pageSize,
      });
      setPaginationInfo(paginationInfoState);
    }
  };

  function getMoreChannel(startIndex) {
    let from = '';
    const { pathname } = location;
    if (Utils.getUrlParam('from') === 'kw') {
      from = Utils.getUrlParam('from');
    } else if (pathname.startsWith('/global.html')) {
      from = Utils.safeEncodeURI(searchResult?.globalSearchKeyword || '');
    } else if (pathname.startsWith('/brand')) {
      from = 'brand';
    } else if (pathname.startsWith('/catalog')) {
      from = 'catalog';
    }
    const paramJson = moreChannelList.slice(startIndex, startIndex + maxObserveIndex);
    if (paramJson.length === 0) {
      return;
    }
    searchMoreChannel({ from, paramJson, index: 0 }).then((res) => {
      if (res?.result && Object.keys(res?.result).length) {
        const list = [];
        const newObj = {};
        const productCodeList = [];
        Object.keys(res?.result).forEach((key) => {
          if (/\d+/.test(key)) {
            if (res?.result[key]?.length > 0) {
              res.result[key].forEach((item) => {
                list.push({
                  provider: item?.provider,
                  brandId: item?.brandId,
                });
                if (Utils.isLcBook(item?.provider)) {
                  productCodeList.push({
                    productCode: item?.productCode,
                    brandId: item?.brandId,
                  });
                }
              });
            }
            newObj[key] = res?.result[key]?.map((item) => {
              return {
                ...providerItemFormat(item),
                track_zone: res?.result?.track_zone,
              };
            });
          }
        });
        setMoreChannelVO((perv) => ({
          ...perv,
          ...newObj,
        }));
        loadMarketCouponLabelShow(productCodeList);
        setOverseaCoupon(list, true);
      }
    });
  }

  // 格式化海外代购/立创订货
  function providerItemFormat(item) {
    const aliasItem = aliasMap.get(item?.provider) || {};
    return {
      ...item,
      providerAlias: aliasItem?.providerAlias || item?.provider,
      canDetailsPage: aliasItem?.providerAlias || false,
      useSourcePartId: aliasItem?.useSourcePartId || false,
    };
  }

  const changePagination = (page) => {
    changeSendSearchParams(
      {
        currentPage: page,
      },
      true,
      null,
      false
    );
  };

  const hasUnitFilterCondition = useMemo(() => {
    return searchResult?.catalogGroup?.length > 0 || searchResult?.gradePlateGroup?.length > 0;
  }, [searchResult?.catalogGroup, searchResult?.gradePlateGroup]);

  return (
    <>
      <Banner imgUrl={props?.bk_bannerImgURL} />
      <div className={'pt-[18px] m-auto _lg:w-[1552px] w-[1200px]'}>
        <div className="flex flex-col mx-auto shrink-0 _lg:w-[1552px] w-[1200px] relative">
          {props?.searchResult?.productRecordList?.length > 0 && hasUnitFilterCondition && (
            <section className="rounded-t-[10px] bg-white ">
              <FilterCondition
                brandFilters={searchResult?.gradePlateGroup}
                catalogFilters={searchResult?.catalogGroup}
                changeSendSearchParams={changeSendSearchParams}
                sendSearchParams={sendSearchParams}
              ></FilterCondition>
            </section>
          )}
          <section
            className={`anchor-header sticky z-[10] left-0 ${anchorHeaderCls} ${anchorHeaderShadow} bg-[#FFFFFF] rounded-b-[10px] mb-[15px]`}
          >
            {props?.searchResult?.productRecordList?.length > 0 && (
              <MixSortFilter
                totalCount={searchResult?.totalCount}
                sendSearchParams={sendSearchParams}
                changeSendSearchParams={changeSendSearchParams}
                checkboxCls={'list-custom-checkbox'}
              ></MixSortFilter>
            )}
          </section>

          <Spin spinning={requestLoading}>
            <ProductList track_zone={props?.track_zone} searchResult={searchResult} showStockBtn={showStockBtn}>
              {!secondQueryIsEmpty &&
                searchResult?.productRecordList.map((item, index) => {
                  const startIndex = (sendSearchParams?.currentPage - 1) * 30;
                  const spm = `xh${startIndex + index + 1}`;
                  let groupHeaderCls = '';
                  if (index % maxObserveIndex === 0) {
                    groupHeaderCls = 'product-group-leader';
                  }
                  return (
                    <div
                      className={`${groupHeaderCls} relative mb-[10px] group`}
                      key={item?.productVO?.productId}
                      data-index={index}
                    >
                      <ProductItem
                        ref={(el) => (productItemRefs.current[index] = el)}
                        offsetTop={196}
                        {...item}
                        moreChannelVO={moreChannelVO[item?.productVO?.productId]}
                        marketLabelVO={marketLabelVO[item?.productVO?.productId]}
                        productSpuMap={productSpuMap[item?.productVO?.productCode]}
                        productConnectorMap={productConnectorMap[item?.productVO?.productCode]}
                        osCoupon={moreOsCoupon}
                        isFavorite={favoriteList?.includes(item?.productVO?.productId)}
                        index={index}
                        spm={spm}
                        dataCustomData={JSON.stringify({
                          productType: 'main',
                          productId: item?.productVO?.productId,
                        })}
                        dhAndTeAndRoCoupon={dhAndTeAndRoCoupon}
                      />
                    </div>
                  );
                })}
              {!secondQueryIsEmpty && paginationInfo?.countPage > 1 && (
                <div className={'m-auto mt-[15px] mb-[30px] flex justify-center'}>
                  <DynamicNormalPagination paginationInfo={paginationInfo} changePagination={changePagination} />
                </div>
              )}
              {(secondQueryIsEmpty || props?.searchResult?.productRecordList?.length === 0) && <EmptyText />}
            </ProductList>
          </Spin>
        </div>
        <DynamicToolbar />
        <DynamicListFloatRightAdvert position={'hot'} />
      </div>
    </>
  );
}

export default memo(HotProductDetailIndex);
